module.exports = __webpack_public_path__ + "static/media/viewall.fe73b0cc.svg";